import Vue from 'vue';
import VueRouter from 'vue-router';
import { routers } from '@/config/router.config';
import { isLogin } from '@/utils/cookie';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes: routers
});

router.beforeEach((to, from, next) => {
  if (to.name !== 'admin.login' && !isLogin()) {
    return next({ name: 'admin.login' });
  }
  return next();
});

router.afterEach((to, from, next) => {
  document.querySelector('title').innerText = `${to.meta.title} | geekchic`;
});

export default router;
